import {DAILY_TOP_DIMS, GROUP_COLORS, GROUP_LABELS, GROUP_ORDER, OTHER_KEY, PIE_REST, PIE_TOP, SERIES_COLORS} from '../constants'
import {dayLabel, monthLabel} from './format'

const _rate = (hits, output) => output ? hits / output : null

export const groupKeys = (appliedGroups) => appliedGroups && appliedGroups.length
    ? GROUP_ORDER.filter(group => appliedGroups.includes(group))
    : GROUP_ORDER

// Cột chồng theo nhóm lỗi: giá trị = lượt lỗi của nhóm ÷ sản lượng của cột
export const groupSeries = (periods, keys, pct = true) => keys.map(key => ({
    label: GROUP_LABELS[key],
    color: GROUP_COLORS[key],
    values: periods.map(period => pct ? _rate(period.by_group[key] || 0, period.output) : (period.by_group[key] || 0)),
    counts: periods.map(period => period.by_group[key] || 0),
}))

const _dimSeries = (periods, keys, dimNames, pct) => keys.map(key => {
    const valueOf = (period) => key === OTHER_KEY
        ? Object.entries(period.by_dim).filter(([dim]) => !keys.includes(dim)).reduce((sum, [, hits]) => sum + hits, 0)
        : (period.by_dim[key] || 0)

    return {
        label: key === OTHER_KEY ? OTHER_KEY : (dimNames[key] || key),
        values: periods.map(period => pct ? _rate(valueOf(period), period.output) : valueOf(period)),
        counts: periods.map(valueOf),
    }
})

// Xu hướng tháng theo đối tượng: toàn bộ đối tượng có lỗi trong kỳ, xếp theo tổng lượt lỗi
export const monthlyDimSeries = (months, dimNames) => {
    const totals = {}
    months.forEach(month => Object.entries(month.by_dim).forEach(([dim, hits]) => {
        totals[dim] = (totals[dim] || 0) + hits
    }))
    const keys = Object.keys(totals).sort((a, b) => totals[b] - totals[a])

    return _dimSeries(months, keys, dimNames, true)
}

// Chi tiết ngày theo đối tượng: 8 đối tượng nhiều lỗi nhất, phần còn lại gộp
export const dailyDimSeries = (days, table, dimNames, pct) => {
    const ranked = table.filter(row => row.hits > 0).map(row => row.dim_id)
    const keys = ranked.length > DAILY_TOP_DIMS ? [...ranked.slice(0, DAILY_TOP_DIMS), OTHER_KEY] : ranked

    return _dimSeries(days, keys, dimNames, pct)
}

export const monthCats = (months) => months.map(month => monthLabel(month.month))

export const dayCats = (days) => days.map(day => dayLabel(day.date))

export const hasDailyOutput = (days) => days.some(day => day.output)

const _color = (index) => index < 0 ? PIE_REST.color : SERIES_COLORS[index % SERIES_COLORS.length]

/**
 * Lát biểu đồ tròn cơ cấu lỗi từ bảng của tab (đã sắp giảm dần theo lượt): PIE_TOP mục đầu, còn lại gộp "Còn lại (n)";
 * chỉ dư đúng một mục thì vẽ luôn mục đó, không gộp.
 * Nhãn cùng nguồn với bảng bên cạnh (dim_name). Màu: nhóm lỗi theo vị trí trong groupKeys, khớp các biểu đồ cột
 * của tab; đối tượng theo thứ hạng trong khoảng ngày, khớp biểu đồ chi tiết ngày (biểu đồ tháng xếp theo cả kỳ
 * nên có thể khác màu, nhãn đã ghi tên nên không cần dò màu)
 */
export const shareSlices = (table, {byGroup = false, keys = GROUP_ORDER} = {}) => {
    const ranked = table.filter(row => row.hits > 0)
    const top = ranked.length === PIE_TOP + 1 ? ranked : ranked.slice(0, PIE_TOP)
    const rest = ranked.slice(top.length)
    const colorOf = (row, index) => byGroup
        ? (GROUP_COLORS[row.dim_id] || _color(keys.indexOf(row.dim_id)))
        : _color(index)
    const slices = top.map((row, index) => ({
        key: row.dim_id,
        label: row.dim_name || GROUP_LABELS[row.dim_id] || row.dim_id,
        value: row.hits,
        share: row.share,
        color: colorOf(row, index),
    }))
    if (!rest.length) return slices

    return [...slices, {
        ...PIE_REST,
        label: `${PIE_REST.label} (${rest.length})`,
        value: rest.reduce((sum, row) => sum + row.hits, 0),
        share: rest.reduce((sum, row) => sum + row.share, 0),
    }]
}
